<section class="organigrama-section">
  <h2 class="organigrama-title">ORGANIGRAMA ITSE</h2>

  <div class="organigrama-container">
    <img src="assets/logos/ORGANIGRAMA_ITSE.jpg" alt="Organigrama ITSE" class="organigrama-img">
  </div>
</section>